import { render, staticRenderFns } from "./SettingUpPopup.vue?vue&type=template&id=956cf8d6&scoped=true&"
import script from "./SettingUpPopup.vue?vue&type=script&lang=js&"
export * from "./SettingUpPopup.vue?vue&type=script&lang=js&"
import style0 from "./SettingUpPopup.vue?vue&type=style&index=0&id=956cf8d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956cf8d6",
  null
  
)

export default component.exports